import React from 'react';
import { FaPhone, FaWhatsapp } from 'react-icons/fa';
import {
  ChannelsSection,
  ChannelsTitle,
  ChannelsContainer,
  ChannelItem,
  ChannelIconContainer,
  ChannelIcon,
  ChannelName,
  DataParticle
} from './ChannelsStyles';

const ChannelsComponent = () => {
  // Função para gerar partículas de dados aleatórias
  const renderDataParticles = (count, containerIndex) => {
    const particles = [];
    const colors = ['#00FFFF', '#64B6FF', '#0080FF', '#FFFFFF'];
    
    for (let i = 0; i < count; i++) {
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const color = colors[Math.floor(Math.random() * colors.length)];
      const duration = `${1 + Math.random() * 2}s`;
      const delay = `${Math.random() * 2}s`;
      
      particles.push(
        <DataParticle 
          key={`particle-${containerIndex}-${i}`}
          top={top}
          left={left}
          color={color}
          duration={duration}
          delay={delay}
        />
      );
    }
    
    return particles;
  };

  return (
    <ChannelsSection>
      <ChannelsTitle>CANAIS DE ATENDIMENTO</ChannelsTitle>
      
      <ChannelsContainer>
        {/* Canal WhatsApp */}
        <ChannelItem delay="0s">
          {renderDataParticles(8, 0)}
          <ChannelIconContainer>
            <ChannelIcon>
              <FaWhatsapp />
            </ChannelIcon>
          </ChannelIconContainer>
          <ChannelName>WhatsApp</ChannelName>
        </ChannelItem>
        
        {/* Canal Ligação */}
        <ChannelItem delay="0.3s">
          {renderDataParticles(8, 1)}
          <ChannelIconContainer>
            <ChannelIcon>
              <FaPhone style={{ transform: 'scaleX(-1)' }} />
            </ChannelIcon>
          </ChannelIconContainer>
          <ChannelName>Ligação</ChannelName>
        </ChannelItem>
      </ChannelsContainer>
    </ChannelsSection>
  );
};

export default ChannelsComponent;
